const PopUpTypes = {
    MESSAGE: "message",
    ERROR: "error",
    CONFIRMATION: "confirmation",
    INFORMATION: "information",
};

export default PopUpTypes;
